//exemplo de middleware que faz
var _timer = 0;


export default ({ getState, dispatch }) => next => action => {
  //pega o state antes de executar a action
  let stateAnterior = getState();
  //.next() passa a action para os proximos middlewares
  //ate chegar nos reducers que atualizam o state
  //retorna o retorno da execucao dos middlewares seguintes
  //ou action caso seja o ultimo middleware em execucao
  let result = next(action);
  //pega o state atualizado
  let stateAtual = getState();
  //aqui ja temos o state atualizados
  clearTimeout(_timer);
  _timer = window.setTimeout(() => {
    window.sessionStorage.setItem('__state-cpa', JSON.stringify(stateAtual));
  }, 1000);
  //o retorno da dispatch
  return result;
};
